export default {
    data() {
        return {
            subscriptions: [],
        }
    },

    beforeDestroy() {
        this.subscriptions.forEach(subscription => {
            if (typeof subscription.pusher !== 'undefined') {
                Echo.leaveChannel(subscription.name)
            } else {
                subscription.unsubscribe()
            }
        })
    },

    methods: {
        subscribe(source, handler) {
            const subscription =
                typeof handler === 'undefined'
                    ? source // when this.subscribe(subscription)
                    : source.subscribe(handler) // when this.subscribe(stream, () => {))

            this.subscriptions.push(subscription)

            return subscription
        },
    },
}
